<template>
    <div
        class="absolute left-4 top-20 rounded bg-gray-225 px-4 py-3 text-[12px] text-gray-625"
    >
        <div class="flex justify-between gap-4 text-[15px] font-semibold">
            <div class="text-gray-725">CAT Debugger</div>
            <div class="hover:cursor-pointer">
                <div class="" v-if="view === 'maximized'" @click="minimize">
                    [-]
                </div>
                <div class="" v-if="view === 'minimized'" @click="maximize">
                    [+]
                </div>
            </div>
        </div>
        <div v-if="view === 'maximized'">
            <div class="flex flex-col">
                <div class="">
                    <span class="font-semibold">MINUTES REMAINING:</span>
                    {{ minutesRemaining }} of
                    {{ catAttempt.allowed_time }}
                </div>
                <div class="">
                    <span class="font-semibold"
                        >TOTAL QUESTIONS ATTEMPTED:</span
                    >
                    {{ catAttempt.questions_attempted ?? 0 }}
                </div>
                <div class="">
                    <span class="font-semibold">QUESTION TIMER:</span>
                    {{ timeSpent }}
                </div>
                <div class="uppercase">
                    <span class="font-semibold">QUESTION FOCUS AREA:</span>
                    {{ question.focus_area.title }}
                </div>
                <div class="">
                    <span class="font-semibold">QUESTION LEVEL:</span>
                    {{ question.metrics[0].difficulty_level }}
                </div>
            </div>
            <div
                class=""
                v-for="(focusArea, id) in catAttempt.focus_areas_performance"
            >
                <span class="font-semibold">FOCUS AREAS ID:</span> {{ id }} |
                PERFORMANCE:
                {{ focusArea }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "StudentComputerAdaptiveTestDebugger",
    props: {
        catAttempt: {},
        minutesRemaining: {},
        question: {},
        timeSpent: {},
    },
    data() {
        return {
            view: "maximized", // or 'minimized'
        };
    },
    methods: {
        minimize() {
            this.view = "minimized";
        },
        maximize() {
            this.view = "maximized";
        },
    },
};
</script>
